import userPerson from '@/view/userPerson/userPerson'
import needlistDetail from '@/view/userPerson/needlistDetail'
import mycaseDetail from '@/view/userPerson/mycaseDetail'
const needRouter = [
  {
    path: '/userPerson/userPerson.html',
    name: 'user-person',
    component: userPerson,
    meta: {
      title: '需求管理'
    }
  },
  {
    path: '/userPerson/needlistDetail.html',
    name: 'user-need-detail',
    component: needlistDetail,
    meta: {
      title: '需求详情'
    }
  },
  {
    path: '/userPerson/mycaseDetail.html',
    name: 'user-mycase-detail',
    component: mycaseDetail,
    meta: {
      title: '订单详情'
    }
  },
]

export default needRouter



// WEBPACK FOOTER //
// ./src/router/userPerson/userPerson.js